<template>
  <v-row>
    <v-col cols="12">
      <v-card flat style="margin-top: 5em">
        <v-card-text>
          <center v-if="loading">
            <v-progress-circular
              color="blue"
              size="80"
              indeterminate
            ></v-progress-circular>
          </center>
          <v-row v-else>
            <v-col cols="12" sm="5" class="pa-0">
              <v-card class="fill-height" flat>
                <v-img height="100%" src="/img/background.png">
                  <v-card-text class="vertical-center" v-if="SelectedPlan">
                    <p
                      class="white--text text-center mt-4 mb-0"
                      style="margin-top: 2em"
                    >
                      Subscribe to Built Payroll for
                    </p>
                    <h1
                      class="white--text text-h5 font-weight-black text-center mt-0 mb-0"
                    >
                      {{ SelectedPlan.base_currency_code
                      }}{{ SelectedPlan.amount | toMoney }}/Month
                    </h1>
                    <p
                      v-if="isGhanaBusiness && SelectedPlan"
                      class="white--text text-center text-body-2 mt-2 mb-0 px-2"
                    >
                      Base subscription rate
                      <strong>
                        {{ SelectedPlan.base_currency_code
                        }}{{ SelectedPlan.amount | toMoney }}
                      </strong>
                      per month before your billing period and statutory levies.
                    </p>
                    <p class="white--text text-center mb-0 mt-0">
                      Billed at least quarterly
                    </p>
                    <h3 class="yellow--text text-center mt-6">
                      For further inquiries contact sales on:
                      <strong>0308040007</strong>
                    </h3>
                  </v-card-text>
                </v-img>
              </v-card>
            </v-col>

            <v-col cols="12" sm="7" class="text-center pa-4">
              <v-card-text class="pa-5">
                <template v-if="isGhanaBusiness && SelectedPlan">
                  <h2 class="text-h5 font-weight-light">
                    Amount:{{ Currency }}{{ Amount | toMoney }}
                  </h2>

                  <h2 v-if="extraCost" class="text-h5 font-weight-light">
                    Extra Cost:{{ Currency }}{{ extraCost | toMoney }}
                  </h2>

                  <h2 v-if="discountAmount" class="text-h5 font-weight-light">
                    Discount Amount({{ discount }}%):{{ Currency
                    }}{{ discountAmount | toMoney }}
                  </h2>

                  <v-sheet
                    color="grey lighten-5"
                    rounded="lg"
                    elevation="0"
                    class="pa-4 mt-4 text-left mx-auto plan-pricing-sheet"
                    max-width="440"
                  >
                    <template v-if="discountAmount > 0">
                      <div
                        class="d-flex justify-space-between caption grey--text text--darken-1"
                      >
                        <span>Before coupon</span>
                        <span style="text-decoration: line-through">{{
                          Currency
                        }}{{ subscriptionBeforeCoupon | toMoney }}</span>
                      </div>
                      <div
                        class="d-flex justify-space-between py-1 success--text caption"
                      >
                        <span>Coupon ({{ discount }}%)</span>
                        <span
                          >− {{ Currency
                          }}{{ discountAmount | toMoney }}</span
                        >
                      </div>
                    </template>
                    <div class="d-flex justify-space-between py-2 body-1">
                      <span>Subscription base (before taxes)</span>
                      <strong
                        >{{ Currency
                        }}{{ subscriptionPayableSubtotal | toMoney }}</strong
                      >
                    </div>
                    <div
                      class="d-flex justify-space-between py-1 grey--text text--darken-1 body-2"
                    >
                      <span>VAT (15% of base)</span>
                      <span>{{ Currency
                      }}{{ ghanaVatAmount | toMoney }}</span>
                    </div>
                    <div
                      class="d-flex justify-space-between py-1 grey--text text--darken-1 body-2"
                    >
                      <span>NHIL (2.5% of base)</span>
                      <span>{{ Currency
                      }}{{ ghanaNhilAmount | toMoney }}</span>
                    </div>
                    <div
                      class="d-flex justify-space-between py-1 grey--text text--darken-1 body-2"
                    >
                      <span>GETFund levy (2.5% of base)</span>
                      <span>{{ Currency
                      }}{{ ghanaGetfundAmount | toMoney }}</span>
                    </div>
                    <v-divider class="my-2"></v-divider>
                    <div
                      class="d-flex justify-space-between text-h6 green--text font-weight-bold"
                    >
                      <span>Total payable</span>
                      <span>{{ Currency
                      }}{{ AmountDue | toMoney }}</span>
                    </div>
                  </v-sheet>
                </template>

                <template v-else>
                  <h2 class="text-h5 font-weight-light">
                    Amount:{{ Currency }}{{ Amount | toMoney }}
                  </h2>

                  <h2 v-if="extraCost" class="text-h5 font-weight-light">
                    Extra Cost:{{ Currency }}{{ extraCost | toMoney }}
                  </h2>

                  <h2 v-if="discountAmount" class="text-h5 font-weight-light">
                    Discount Amount({{ discount }}%):{{ Currency
                    }}{{ discountAmount | toMoney }}
                  </h2>

                  <h2
                    v-if="discountAmount"
                    style="text-decoration: line-through"
                    class="text-h5 font-weight-light"
                  >
                    Amount Due:{{ Currency }}{{ totalAmount | toMoney }}
                  </h2>

                  <h2 class="text-h4 font-weight-light">
                    Amount Due:{{ Currency }}{{ AmountDue | toMoney }}
                  </h2>
                </template>

                <v-autocomplete
                  :items="cycles"
                  outlined
                  label="Billing Cycle"
                  class="mt-3"
                  v-model="cycle"
                >
                </v-autocomplete>

                <!--                <p>Current number of employees: {{ currentEMployeeCount }}</p>-->
                <!--                <p>Current Limit: {{ currentLimit }}</p>-->
                <!--                <p class="font-weight-black">New Limit: {{ newLimit }}</p>-->
                <!--                <p class="orange&#45;&#45;text">Each extra employee will cost:-->
                <!--                  {{ Currency }}{{ AmountPerEmployee | toMoney }}</p>-->

                <!--                <h2 v-if="extraEmployees" class="green&#45;&#45;text font-weight-black mb-3">{{ extraEmployees }} extra-->
                <!--                  employees will cost {{ Currency }}{{ extraCost | toMoney }}</h2>-->

                <!--                <v-text-field-->
                <!--                    type="number"-->
                <!--                    outlined-->
                <!--                    min="0"-->
                <!--                    label="Add more employees"-->
                <!--                    v-model="extraEmployees"-->
                <!--                    prepend-inner-icon="mdi-account-outline"-->
                <!--                ></v-text-field>-->

                <v-btn
                  :loading="progress"
                  @click="subscribe()"
                  :disabled="!SelectedPlan || !cardIntervalIsValid(cycle)"
                  block
                  x-large
                  color="green"
                  class="mt-4 white--text"
                  rounded
                  depressed
                  >Pay With Card
                </v-btn>

                <v-card
                  v-if="!cardIntervalIsValid(cycle)"
                  color="blue-grey lighten-5"
                  class="mt-3"
                  outlined
                  style="border-left: 4px solid #ff9800; border-radius: 8px"
                >
                  <v-card-text class="pa-3 text-left">
                    <div class="d-flex align-start">
                      <v-icon small color="orange darken-2" class="mr-2 mt-1"
                        >mdi-information-outline</v-icon
                      >
                      <div class="body-2 grey--text text--darken-1 text-left">
                        Card payments are only available for monthly, quarterly,
                        every 6 months, or annual billing cycles.
                      </div>
                    </div>
                  </v-card-text>
                </v-card>

                <v-btn
                  v-if="!progress"
                  @click="momoCheckout = true"
                  block
                  x-large
                  color="blue darken-4"
                  class="mt-4"
                  rounded
                  depressed
                  dark
                  >Pay With
                  {{
                    business.country.code === "KE" ? "Mpesa" : "Mobile Money"
                  }}
                </v-btn>
                <v-btn
                  v-if="!progress"
                  @click="showDialog = true"
                  text
                  block
                  x-large
                  class="mt-3"
                  rounded
                  depressed
                  >Apply Coupon
                </v-btn>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-dialog v-model="showDialog" width="400">
        <v-card>
          <v-card-title>
            Apply coupon
            <v-spacer></v-spacer>
            <v-btn
              @click="showDialog = false"
              color="red lighten-5 red--text"
              depressed
              rounded
              small
              >Close
              <v-icon color="red" small>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-form ref="coupon_form">
              <v-text-field
                v-model="couponCode"
                :rules="$store.state.required_rules"
                outlined
                label="Coupon code"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              :loading="progress"
              @click="submitCoupon"
              x-large
              block
              color="blue darken-4"
              dark
              rounded
              depressed
            >
              Submit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="momoCheckout"
        :fullscreen="$vuetify.breakpoint.mobile"
        persistent
        width="500"
        v-if="SelectedPlan"
      >
        <v-card>
          <v-card-title class="font-weight-light">
            Pay with
            {{
              ["GH", "RW", "SL"].includes(business.country.code)
                ? "Mobile Money"
                : "Mpesa"
            }}
            <v-spacer></v-spacer>
            <v-btn
              color="red lighten-5 red--text"
              depressed
              rounded
              small
              @click="momoCheckout = false"
              >close
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <checkout
            :account_id="0"
            :amount="AmountDue"
            :cost-breakdown="ghanaCostBreakdown"
            :discounted-price="AmountDue"
            :is-eligible-for-discount="false"
            :record_id="cycle"
            :meta-data="employeesExtension"
            :record_type="'subscription-' + SelectedPlan.name.toLowerCase()"
            :subscription-coupon="couponCode"
            @paymentComplete="send_success"
          ></checkout>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import { defineComponent } from "vue";
import Checkout from "@/components/Checkout.vue";
import moment from "moment";

const CARD_INTERVALS = [
  {
    months: 1,
    value: "monthly",
    label: "Monthly",
    description: "charged every month",
  },
  {
    months: 3,
    value: "quarterly",
    label: "Quarterly",
    description: "charged every 3 months",
  },
  {
    months: 6,
    value: "six_months",
    label: "Six months",
    description: "charged every 6 months",
  },
  {
    months: 12,
    value: "annually",
    label: "Annually",
    description: "charged once a year",
  },
];

export default defineComponent({
  name: "SubscriptionComponent",
  components: { Checkout },
  data() {
    return {
      showDialog: false,
      plans: [],
      loading: false,
      progress: false,
      cycle: 3,
      defaultLimit: 20,
      discount: 0,
      currentEMployeeCount: 0,
      amountPerEmployeeUSD: 5,
      extraEmployees: 0,
      couponCode: "",
      momoCheckout: false,
      interval: "monthly",
    };
  },
  computed: {
    employeesExtension() {
      return {
        amount: this.extraCost,
        defaultNumber: 20,
        extraNumber: this.extraEmployees,
        totalNumber: this.newLimit,
      };
    },
    totalAmount() {
      return this.Amount + this.extraCost;
    },
    discountAmount() {
      const discount = Number(this.discount);

      const amount = discount <= 0 ? 0 : (discount / 100) * this.totalAmount;

      return Number(amount.toFixed(2));
    },
    newLimit() {
      return Number(this.extraEmployees) + Number(this.defaultLimit);
    },

    currentLimit() {
      if (this.currentEMployeeCount > this.defaultLimit) {
        return 0;
      }

      return this.defaultLimit - this.currentEMployeeCount;
    },

    extraCost() {
      return this.AmountPerEmployee * this.extraEmployees;
    },
    AmountPerEmployee() {
      if (!this.SelectedPlan) {
        return 0;
      }
      return this.SelectedPlan.rate.rate * this.amountPerEmployeeUSD;
    },

    isGhanaBusiness() {
      return (this.business?.country?.code || "").toUpperCase() === "GH";
    },

    /** Pre-tax total after coupon (tax base for Ghana). */
    subscriptionPayableSubtotal() {
      return this.roundMoney(this.Amount + this.extraCost - this.discountAmount);
    },

    /** Amount + extra before coupon (for "before coupon" line). */
    subscriptionBeforeCoupon() {
      return this.roundMoney(this.Amount + this.extraCost);
    },

    ghanaVatAmount() {
      if (!this.isGhanaBusiness) return 0;
      return this.roundMoney(this.subscriptionPayableSubtotal * 0.15);
    },

    ghanaNhilAmount() {
      if (!this.isGhanaBusiness) return 0;
      return this.roundMoney(this.subscriptionPayableSubtotal * 0.025);
    },

    ghanaGetfundAmount() {
      if (!this.isGhanaBusiness) return 0;
      return this.roundMoney(this.subscriptionPayableSubtotal * 0.025);
    },

    ghanaCostBreakdown() {
      if (!this.isGhanaBusiness) return null;
      const base = this.subscriptionPayableSubtotal;
      const vat = this.ghanaVatAmount;
      const nhil = this.ghanaNhilAmount;
      const getfund = this.ghanaGetfundAmount;
      const total = this.roundMoney(base + vat + nhil + getfund);
      return { base, vat, nhil, getfund, total };
    },

    AmountDue() {
      const net = this.roundMoney(this.Amount + this.extraCost - this.discountAmount);
      if (!this.isGhanaBusiness) {
        return net;
      }
      return this.roundMoney(
        net +
          this.ghanaVatAmount +
          this.ghanaNhilAmount +
          this.ghanaGetfundAmount
      );
    },

    Currency() {
      if (this.SelectedPlan) {
        return this.SelectedPlan.base_currency_code;
      }

      return "";
    },

    Amount() {
      if (this.SelectedPlan) {
        return this.SelectedPlan.amount * this.cycle;
      }

      return 0;
    },

    cycles() {
      let list = [];

      for (let i = 3; i <= 12; i++) {
        list.push({
          value: i,
          text: i + " Months",
        });
      }
      list.push({ value: 24, text: "24 Months" });
      list.push({ value: 36, text: "36 Months" });
      list.push({ value: 48, text: "48 Months" });

      return list;
    },
    business() {
      return this.$store.state.user.current_business;
    },
    SelectedPlan() {
      return this.plans.find((item) => {
        return item.name.toLowerCase() === "starter";
      });
    },
    reference() {
      let text = "";
      let possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (let i = 0; i < 10; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      let d = new Date();
      let timestamp = d.getTime();
      return "Subscription_" + timestamp + "" + text;
    },
  },
  methods: {
    roundMoney(value) {
      return Math.round(Number(value || 0) * 100) / 100;
    },

    cardIntervalEntry(months) {
      return CARD_INTERVALS.find((entry) => entry.months === months);
    },

    intervalFromMonths(months) {
      const entry = this.cardIntervalEntry(months);
      return entry ? entry.value : null;
    },

    cardIntervalIsValid(months) {
      return Boolean(this.intervalFromMonths(months));
    },

    send_success() {
      location.reload();
    },

    send_success_direct() {
      this.progress = true;
      let formData = new FormData();
      formData.append("startdate", moment().format("Y-M-D"));
      formData.append(
        "enddate",
        moment().add(this.cycle, "months").format("Y-M-D")
      );
      formData.append("amount", this.AmountDue);
      formData.append("plan", this.SelectedPlan.name.toLowerCase());
      formData.append("coupon_applied", this.discount > 0);
      formData.append("coupon_code", this.couponCode);
      formData.append("billing_cycle", this.cycle);
      // eslint-disable-next-line no-undef
      axios
        .post("/appsubcription", formData)
        .then(() => {
          location.reload();
          // this.finish_sub();
        })
        .catch(() => {
          this.progress = false;
          // this.error_msg =
          //     "Something went wrong, could not save your subscription, please try again";
          // this.error_message = true;
        });
    },
    subscribe() {
      this.progress = true;
      const planName = this.SelectedPlan?.name ?? this.SelectedPlan?.planname;

      if (!planName) {
        this.progress = false;
        return;
      }

      this.interval = this.intervalFromMonths(this.cycle) || "monthly";

      const payload = this.isGhanaBusiness
        ? {
            interval: this.cycle,
            plan_name: planName.toLowerCase(),
            coupon: this.couponCode || "",
            current_plan_id: "",
            change_current_plan_id: "",
          }
        : {
            plan_name: planName,
            interval: this.interval,
          };

      axios
        .post(
          this.isGhanaBusiness
            ? "/paystack/init-subscription"
            : "/stripe/init-subscription",
          payload
        )
        .then((res) => {
          window.open(res.data.url);
          this.progress = false;
        })
        .catch((error) => {
          this.progress = false;
        });
    },

    submitCoupon() {
      if (this.$refs.coupon_form.validate()) {
        this.progress = true;
        const code = this.couponCode;

        const data = {
          code: code,
        };

        // eslint-disable-next-line no-undef
        axios
          .post("/coupon", data)
          .then((res) => {
            this.progress = false;

            this.discount = res.data.discount;

            if (this.discount >= 100) {
              this.send_success_direct();
            } else {
              this.showDialog = false;
            }
          })
          .catch(() => {
            this.progress = false;
          });
      }
    },

    getEmployeeCount() {
      this.progress = true;

      // eslint-disable-next-line no-undef
      axios.get("/employees/count").then((res) => {
        this.currentEMployeeCount = res.data.employee_count;
        this.progress = false;
      });
    },
    getPlans() {
      this.loading = true;
      // eslint-disable-next-line no-undef
      axios
        .get("/subscriptionplans/" + this.business.country_id)
        .then((res) => {
          this.plans = res.data;

          this.loading = false;
        });
    },
  },
  mounted() {
    this.getPlans();
    this.getEmployeeCount();
  },
});
</script>

<style scoped>
.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.v-btn.v-btn--disabled {
  background-color: #e0e0e0 !important;
  color: #9e9e9e !important;
  opacity: 1 !important;
}

.plan-pricing-sheet {
  border: 1px solid rgba(0, 0, 0, 0.06);
}
</style>
